import React, { useState } from 'react';
import axios from '../api/axiosConfig';

const TIPOS_DOC = [
  ['CC', 'cédula de ciudadanía'], ['NIT', 'nit'], ['CE', 'cédula de extranjería'],
  ['PP', 'pasaporte'], ['PPT', 'permiso de permanencia temporal (PPT)'], ['TI', 'tarjeta de identidad']
];
const EXT_OK = ['pdf', 'jpg', 'jpeg', 'png', 'webp'];
const DOCS = {
  Cedula_Propietario: 'IDENTIFICACIÓN DEL PROPIETARIO',
  Cedula_Comprador: 'IDENTIFICACIÓN DEL COMPRADOR',
  Contrato_Compraventa: 'CONTRATO DE COMPRAVENTA',
  Paz_Salvo_Acreedor: 'PAZ Y SALVO DEL ACREEDOR PRENDARIO'
};
const docsRequeridos = (subtipo, conLevante) => subtipo === 'levantamiento_prenda'
  ? ['Cedula_Propietario', 'Paz_Salvo_Acreedor']
  : ['Cedula_Propietario', 'Cedula_Comprador', 'Contrato_Compraventa', ...(conLevante ? ['Paz_Salvo_Acreedor'] : [])];

const Estado = ({ ok, children }) => (
  <div style={{ color: ok ? '#15803d' : '#b91c1c', fontWeight: 600 }}>{ok ? '✅' : '❌'} {children}</div>
);

const personaVacia = (tipo = 'CC') => ({ tipo_documento: tipo, documento: '', nombre: '', correo: '', telefono: '', direccion: '', estado_persona: null, tiene_multas: false });

// Validación de identidad de una persona (consulta RUNT/SIMIT con el endpoint de propietarios)
const Persona = ({ titulo, icono, p, setP, conContacto, aviso }) => {
  const [buscando, setBuscando] = useState(false);
  const set = (k, v) => setP(prev => ({ ...prev, [k]: v }));
  const buscar = async () => {
    if (!p.documento) { alert('⚠️ Ingrese el documento'); return; }
    setBuscando(true);
    try {
      const res = await axios.get(`/api/tramites/owner/${p.documento}?tipo_documento_id=${p.tipo_documento}`);
      if (res.data) {
        setP(prev => ({
          ...prev,
          nombre: res.data.propietario || prev.nombre,
          correo: res.data.correo || prev.correo, telefono: res.data.telefono || prev.telefono, direccion: res.data.direccion || prev.direccion,
          estado_persona: res.data.estado_persona || null, tiene_multas: Boolean(res.data.tiene_multas), consultado: true
        }));
        if (res.data.tiene_multas) alert(`🚨 ${titulo}: presenta multas en SIMIT.`);
      }
    } catch (err) {
      alert(err.response?.status === 404 ? 'ℹ️ Persona no encontrada. Ingrese los datos manualmente.' : '❌ Error al consultar');
    } finally { setBuscando(false); }
  };
  const req = <span style={{ color: 'red' }}>*</span>;
  const activo = p.estado_persona && String(p.estado_persona).toUpperCase().includes('ACTIV');
  return (
    <div className="form-section">
      <div className="form-section-header">
        <div className="form-section-icon">{icono}</div>
        <h4 className="form-section-title">VALIDACIÓN DE IDENTIDAD: {titulo}</h4>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: '12px', marginTop: '12px' }}>
        <div className="form-group">
          <label>TIPO DOC. {req}</label>
          <select value={p.tipo_documento} onChange={(e) => set('tipo_documento', e.target.value)}>
            {TIPOS_DOC.map(([k, l]) => <option key={k} value={k}>{l}</option>)}
          </select>
        </div>
        <div className="form-group">
          <label>NRO DE DOCUMENTO {req}</label>
          <div style={{ display: 'flex', gap: '10px' }}>
            <input type="text" value={p.documento} onChange={(e) => set('documento', e.target.value.toUpperCase())} style={{ flex: 1 }} />
            <button type="button" className="btn-action btn-modules" onClick={buscar} disabled={buscando}
              style={{ padding: '0 20px', height: '45px', fontWeight: '800' }}>{buscando ? '⏳' : 'CONSULTAR'}</button>
          </div>
        </div>
      </div>
      {p.consultado && (
        <div style={{ fontSize: '12px', margin: '4px 0 8px 0', fontWeight: 600, color: activo ? '#15803d' : '#b45309' }}>
          {activo ? '✅ Activo en RUNT' : `⚠️ ${p.estado_persona || 'Sin registro en RUNT'}`}{p.tiene_multas ? ' · 🚨 Con multas en SIMIT' : ''}
        </div>
      )}
      {aviso && <div style={{ fontSize: '12px', color: '#b45309', marginBottom: '8px' }}>{aviso}</div>}
      <div className="form-grid">
        <div className="form-group"><label>NOMBRE / RAZÓN SOCIAL {req}</label>
          <input type="text" value={p.nombre} onChange={(e) => set('nombre', e.target.value.toUpperCase())} /></div>
        <div className="form-group"><label>TELÉFONO</label>
          <input type="text" value={p.telefono} onChange={(e) => set('telefono', e.target.value)} /></div>
        {conContacto && <>
          <div className="form-group"><label>CORREO</label>
            <input type="email" value={p.correo} onChange={(e) => set('correo', e.target.value)} /></div>
          <div className="form-group"><label>DIRECCIÓN</label>
            <input type="text" value={p.direccion} onChange={(e) => set('direccion', e.target.value.toUpperCase())} /></div>
        </>}
      </div>
    </div>
  );
};

const FormularioTraspaso = ({ subtipo, tipoTramiteId, transitoId, onClose, onSuccess }) => {
  const esLevante = subtipo === 'levantamiento_prenda';
  const titulo = esLevante ? 'LEVANTAMIENTO DE PRENDA' : 'TRASPASO';
  const [placa, setPlaca] = useState('');
  const [conLevante, setConLevante] = useState(false);
  const [consultando, setConsultando] = useState(false);
  const [info, setInfo] = useState(null);
  const [errorPlaca, setErrorPlaca] = useState('');
  const [enviando, setEnviando] = useState(false);
  const [archivos, setArchivos] = useState({});
  const [propietario, setPropietario] = useState(personaVacia());
  const [comprador, setComprador] = useState(personaVacia());
  const [acreedor, setAcreedor] = useState(personaVacia('NIT'));
  const [observaciones, setObservaciones] = useState('');
  const pidePrenda = esLevante || conLevante;

  const consultarPlaca = async (levante = conLevante) => {
    const p = placa.trim().toUpperCase();
    if (p.length < 5) { alert('⚠️ Ingrese la placa del vehículo'); return; }
    setConsultando(true); setErrorPlaca(''); setInfo(null);
    try {
      const res = await axios.get('/api/tramites/traspaso/lookup', {
        params: { placa: p, subtipo, transito_id: transitoId, con_levante: !esLevante && levante, forzar: true }, timeout: 120000
      });
      setInfo(res.data);
      // Datos del propietario según RUNT
      const pr = res.data.propietario_runt;
      if (pr && !propietario.documento) setPropietario(prev => ({ ...prev, documento: pr.documento, nombre: pr.nombre || prev.nombre }));
    } catch (err) {
      setErrorPlaca(err.response?.data?.message || 'No se pudo consultar la placa');
    } finally { setConsultando(false); }
  };

  const cambiarLevante = (v) => {
    setConLevante(v);
    if (info) consultarPlaca(v); // revalida (en algunos tránsitos el levantamiento se radica aparte)
  };

  const elegirArchivo = (campo, e) => {
    const file = e.target.files[0];
    if (!file) { setArchivos(a => ({ ...a, [campo]: null })); return; }
    const ext = file.name.split('.').pop().toLowerCase();
    if (!EXT_OK.includes(ext)) { alert(`❌ "${file.name}" no es PDF ni imagen.`); e.target.value = ''; return; }
    if (file.size > 6 * 1024 * 1024) { alert(`❌ "${file.name}" supera los 6MB`); e.target.value = ''; return; }
    setArchivos(a => ({ ...a, [campo]: file }));
  };

  const requeridos = docsRequeridos(subtipo, conLevante);

  const enviar = async () => {
    if (!info || !info.puede_crear) { alert('⚠️ Consulte primero una placa que cumpla los requisitos'); return; }
    if (!propietario.nombre.trim() || !propietario.documento.trim()) { alert('⚠️ Complete los datos del propietario'); return; }
    if (!esLevante && (!comprador.nombre.trim() || !comprador.documento.trim())) { alert('⚠️ Complete los datos del comprador'); return; }
    if (pidePrenda && (!acreedor.nombre.trim() || !acreedor.documento.trim())) { alert('⚠️ Complete los datos del acreedor prendario'); return; }
    const pr = info.propietario_runt;
    if (pr && pr.documento && String(pr.documento) !== String(propietario.documento).trim()
      && !window.confirm(`⚠️ El RUNT reporta como propietario el documento ${pr.documento}${pr.nombre ? ` (${pr.nombre})` : ''}, distinto al digitado (${propietario.documento}). ¿Desea continuar?`)) return;
    const faltan = requeridos.filter(c => !archivos[c]).map(c => DOCS[c]);
    if (faltan.length) { alert(`⚠️ Faltan documentos obligatorios:\n• ${faltan.join('\n• ')}`); return; }
    const total = requeridos.reduce((a, c) => a + (archivos[c]?.size || 0), 0);
    if (total > 25 * 1024 * 1024) { alert('❌ La suma de los archivos no puede superar 25MB'); return; }

    setEnviando(true);
    const data = new FormData();
    data.append('transito_id', transitoId);
    data.append('tipo_tramite_id', tipoTramiteId);
    data.append('placa_referencia', info.placa);
    data.append('datos_adicionales', JSON.stringify({
      placa_referencia: info.placa, observaciones, incluye_levante_prenda: !esLevante && conLevante,
      propietario: propietario.nombre, tipo_documento: propietario.tipo_documento, documento: propietario.documento,
      correo: propietario.correo, telefono: propietario.telefono, direccion: propietario.direccion,
      estado_persona: propietario.estado_persona, tiene_multas: propietario.tiene_multas,
      ...(!esLevante ? {
        comprador_nombre: comprador.nombre, comprador_tipo_documento: comprador.tipo_documento, comprador_documento: comprador.documento,
        comprador_telefono: comprador.telefono, comprador_correo: comprador.correo, comprador_direccion: comprador.direccion,
        comprador_estado_persona: comprador.estado_persona, comprador_tiene_multas: comprador.tiene_multas
      } : {}),
      ...(pidePrenda ? {
        acreedor_nombre: acreedor.nombre, acreedor_tipo_documento: acreedor.tipo_documento, acreedor_documento: acreedor.documento,
        acreedor_estado_persona: acreedor.estado_persona
      } : {})
    }));
    requeridos.forEach(c => data.append(c, archivos[c]));
    try {
      const res = await axios.post('/api/tramites', data, { headers: { 'Content-Type': 'multipart/form-data' }, timeout: 180000 });
      alert(`✅ ${res.data?.message || 'Trámite radicado'}\n\nYa puede descargar el FUN y el contrato de mandato desde el detalle del trámite.`);
      onSuccess(); onClose();
    } catch (err) {
      alert('❌ Error: ' + (err.response?.data?.message || 'No se pudo crear el trámite'));
    } finally { setEnviando(false); }
  };

  const req = <span style={{ color: 'red' }}>*</span>;
  const v = info?.vehiculo || {};

  return (
    <div>
      <div className="form-section">
        <div className="form-section-header">
          <div className="form-section-icon">🚗</div>
          <h4 className="form-section-title">PLACA DEL VEHÍCULO ({titulo})</h4>
        </div>
        <small style={{ display: 'block', margin: '8px 0' }}>
          Se busca la placa en TransiApp (si no está, se radica como placa nueva) y se consulta el RUNT: SOAT y revisión técnico-mecánica vigentes,
          y que el organismo de tránsito escogido sea donde está matriculado el vehículo. El CUPL lo carga el tránsito al recibir la solicitud.
        </small>
        <div style={{ display: 'flex', gap: '10px' }}>
          <input type="text" value={placa} maxLength={7} placeholder="PLACA"
            onChange={(e) => { setPlaca(e.target.value.toUpperCase()); setInfo(null); setErrorPlaca(''); }}
            onKeyDown={(e) => e.key === 'Enter' && (e.preventDefault(), consultarPlaca())}
            style={{ flex: 1, textTransform: 'uppercase', fontWeight: 'bold' }} />
          <button type="button" className="btn-action btn-modules" onClick={() => consultarPlaca()} disabled={consultando}
            style={{ padding: '0 20px', height: '45px', fontWeight: '800' }}>
            {consultando ? '⏳ CONSULTANDO...' : 'CONSULTAR'}
          </button>
        </div>
        {!esLevante && (
          <label style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '12px', fontWeight: 700, cursor: 'pointer' }}>
            <input type="checkbox" checked={conLevante} onChange={(e) => cambiarLevante(e.target.checked)} style={{ width: '18px', height: '18px', margin: 0 }} />
            ➕ ADICIONAR LEVANTAMIENTO DE PRENDA
          </label>
        )}
        {consultando && <small style={{ display: 'block', marginTop: '6px' }}>Consultando el RUNT, puede tardar hasta 30 segundos...</small>}
        {errorPlaca && <div className="error-banner" style={{ marginTop: '10px' }}>{errorPlaca}</div>}
        {info && (
          <div style={{ marginTop: '12px', padding: '12px', borderRadius: '8px', border: '1px solid var(--card-border)', background: 'var(--secondary-soft)', fontSize: '13px', display: 'grid', gap: '6px' }}>
            <div><b>Vehículo:</b> {[v.marca, v.linea, v.modelo, v.color, v.clase].filter(Boolean).join(' · ') || 'sin datos'}</div>
            {(v.motor || v.chasis) && <div><b>Motor:</b> {v.motor || '-'} · <b>Chasis:</b> {v.chasis || '-'}{v.cilindraje ? ` · ${v.cilindraje} cc` : ''}</div>}
            <div><b>En TransiApp:</b> {info.en_transiapp ? `trámite #${info.en_transiapp.id} (${info.en_transiapp.tipo || ''} · ${info.en_transiapp.transito || ''})` : 'no está registrada; se radica como placa nueva'}</div>
            <Estado ok={info.soat?.ok}>SOAT {info.soat?.ok ? `vigente${info.soat.fecha_fin ? ' hasta ' + info.soat.fecha_fin : ''}` : 'NO vigente'}</Estado>
            <Estado ok={info.rtm?.ok}>
              Revisión técnico-mecánica {info.rtm?.ok ? (info.rtm.estado === 'no_aplica' ? 'no aplica (vehículo nuevo)' : 'vigente') : 'NO vigente'}
            </Estado>
            {info.organismo
              ? <Estado ok={String(info.organismo.id) === String(info.transito?.id)}>Matriculada en {info.organismo.nombre} ({info.organismo.fuente})</Estado>
              : null}
            {info.propietario_runt && <div><b>Propietario según RUNT:</b> {info.propietario_runt.nombre || ''} · {info.propietario_runt.documento}</div>}
            {info.gravamen !== null && <div><b>Prenda (gravamen) en RUNT:</b> {info.gravamen ? 'SÍ' : 'NO'}</div>}
            {!esLevante && conLevante && (
              <div style={{ color: '#5b21b6', fontWeight: 600 }}>
                {info.levante_conjunto
                  ? `ℹ️ ${info.transito?.nombre} cobra traspaso y levantamiento en conjunto: un solo trámite con un solo CUPL ($${Number(info.valor_cupl_conjunto || 0).toLocaleString('es-CO')}).`
                  : `ℹ️ Se radica un solo trámite de traspaso con levantamiento de prenda.`}
              </div>
            )}
            {(info.avisos || []).map((a, i) => <div key={`a${i}`} style={{ color: '#b45309', fontWeight: 600 }}>⚠️ {a}</div>)}
            {(info.bloqueos || []).map((b, i) => <div key={i} className="error-banner" style={{ marginTop: '4px' }}>{b}</div>)}
          </div>
        )}
      </div>

      {info && info.puede_crear && (
        <>
          <Persona titulo="PROPIETARIO" icono="🧾" p={propietario} setP={setPropietario} conContacto={esLevante}
            aviso={info.propietario_runt && propietario.documento && String(info.propietario_runt.documento) !== String(propietario.documento).trim()
              ? `El RUNT reporta como propietario el documento ${info.propietario_runt.documento}.` : null} />
          {!esLevante && <Persona titulo="COMPRADOR" icono="👤" p={comprador} setP={setComprador} conContacto />}
          {pidePrenda && <Persona titulo="ACREEDOR PRENDARIO" icono="🏦" p={acreedor} setP={setAcreedor} />}

          <div className="form-section">
            <div className="form-section-header">
              <div className="form-section-icon">📎</div>
              <h4 className="form-section-title">DOCUMENTACIÓN</h4>
            </div>
            {requeridos.map(c => (
              <div className="form-group" key={c}>
                <label>{DOCS[c]} {req}</label>
                <input type="file" accept=".pdf,.jpg,.jpeg,.png,.webp" onChange={(e) => elegirArchivo(c, e)} />
                {archivos[c] && <small style={{ color: '#16a34a' }}>✓ {archivos[c].name}</small>}
              </div>
            ))}
            <small style={{ display: 'block', color: '#64748b' }}>Al radicar podrá descargar el FUN y el contrato de mandato diligenciados.</small>
            <div className="form-group" style={{ marginTop: '10px' }}>
              <label>OBSERVACIONES</label>
              <textarea value={observaciones} onChange={(e) => setObservaciones(e.target.value.toUpperCase())} rows={2} />
            </div>
          </div>
        </>
      )}

      <div className="modal-actions" style={{ padding: '0 20px 20px 20px' }}>
        <button type="button" onClick={onClose} className="btn-secondary" disabled={enviando}>cancelar</button>
        <button type="button" onClick={enviar} className="btn-primary" disabled={enviando || !info || !info.puede_crear}
          style={{ padding: '10px 25px', fontSize: '13px', fontWeight: '800' }}>
          {enviando ? '🚀 ENVIANDO...' : `🚀 RADICAR ${titulo}${!esLevante && conLevante ? ' + LEVANTAMIENTO' : ''}`}
        </button>
      </div>
    </div>
  );
};

export default FormularioTraspaso;
